import { useEffect, useRef, useState } from 'react';

import { EditableFieldProps } from '.';

export const useEditableField = ({ onChange, initialValue }: EditableFieldProps) => {
  const [value, setValue] = useState(initialValue);

  const [isFocused, setIsFocused] = useState(false);
  const [isEscPressed, setIsEscPressed] = useState(false);

  const inputElement = useRef<HTMLTextAreaElement>(null);
  const valueContainerRef = useRef<HTMLDivElement>(null);

  const onInputEnd = () => {
    onChange(value);
    setIsFocused(false);
  };

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue, isEscPressed]);

  return [
    value,
    setValue,
    isFocused,
    onInputEnd,
    setIsFocused,
    inputElement,
    isEscPressed,
    setIsEscPressed,
    valueContainerRef
  ] as const;
};
